import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { BILLING_PATH, PLAN_FEATURE_LABELS } from '../utils/planAccess';

const PLAN_FEATURE_I18N_KEYS = {
  exportData: 'planFeatureExportData',
  taskPresets: 'planFeatureTaskPresets',
  checklistPresets: 'planFeatureChecklistPresets',
  taskImageUploads: 'planFeatureTaskImageUploads',
  handouts: 'planFeatureHandouts',
  advancedAnalytics: 'planFeatureAdvancedAnalytics',
  customIntegrations: 'planFeatureCustomIntegrations',
  taskWorkGroups: 'planFeatureTaskWorkGroups'
};

const UpgradeCta = ({ className, as = 'p', capability }) => {
  const { t } = useTranslation('common');
  const Tag = as;
  const featureKey = capability ? PLAN_FEATURE_I18N_KEYS[capability] : null;
  const featureName = capability ? PLAN_FEATURE_LABELS[capability] : null;
  const message = featureKey
    ? t('upgradeCtaFeature', { feature: t(featureKey) || featureName?.toLowerCase() })
    : t('upgradeCtaDefault');

  return (
    <Tag className={className}>
      {message}{' '}
      <Link to={BILLING_PATH}>{t('manageBilling')}</Link>
    </Tag>
  );
};

export default UpgradeCta;
